import {
  Overview as OverviewIcon,
  Applicantions as ApplicantionsIcon,
  Researchers as ResearchersIcon,
} from "../../Components/Icon";
import Researchers from "../../Pages/Applicants/Researchers";
import Applications from "../../Pages/Applicants/Applications";
import Overview from "../../Pages/Applicants/Overview";

const navigation = {
  header: "Applicants",
  links: [
    { text: "Overview", icon: OverviewIcon, route: "overview", component: Overview },
    {
      text: "Researchers",
      icon: ApplicantionsIcon,
      route: "researchers",
      component: Researchers,
    },
    {
      text: "Applications",
      icon: ResearchersIcon,
      route: "applications",
      component: Applications,
    },
  ],
};
export default navigation;
